export enum DeviceGlobalStatusEnum {
  Ok = 0,
  Warning = 1,
  PartiallyBlocked = 2,
  Blocked = 3,
  NotReceivingData = 4,
  Unknown = -1,
}
